// Minimum length for slug
export const SLUG_MIN_LENGTH = 5;

/**
 * Validates if a slug is valid
 * @param {string} slug - The slug to validate
 * @returns {Object} { isValid: boolean, error: string | null }
 */
export const validateSlug = slug => {
    // Check if slug is empty
    if (!slug) {
        return {
            isValid: false,
            error: 'Slug is required',
        };
    }

    // Check if slug contains only lowercase letters, numbers and underscores
    if (!/^[a-z0-9_]+$/.test(slug)) {
        return {
            isValid: false,
            error: 'Slug must contain only lowercase letters, numbers, and underscores',
        };
    }

    // Check if slug contains at least one letter
    if (!/[a-z]/.test(slug)) {
        return {
            isValid: false,
            error: 'Slug must contain at least one letter',
        };
    }

    // Check minimum length
    if (slug.length < SLUG_MIN_LENGTH) {
        return {
            isValid: false,
            error: `Slug must be at least ${SLUG_MIN_LENGTH} characters long`,
        };
    }

    return { isValid: true, error: null };
};

/**
 * Generates a slug from a name
 * @param {string} name - The name to generate slug from
 * @returns {string} The generated slug
 */
export const generateSlug = name => {
    return name.toLowerCase()
        .replace(/\s+/g, '_')    // Replace spaces with underscores
        .replace(/[^\w]+/g, '')  // Remove non-word chars
        .replace(/_+/g, '_')     // Replace multiple underscores with single
        .replace(/^_+/, '')      // Trim underscores from start
        .replace(/_+$/, '');     // Trim underscores from end
};
